import Vue from 'vue';
import Vuex from 'vuex';

import mutations  from './modules/mutations';
import state  from './modules/state';
import * as getters from './getters'

Vue.use(Vuex);
  const store = new Vuex.Store({
    mutations,
    getters,
    state
       
});
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js